'use client';
import NextLink from 'next/link';
import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface LinkProps {
  href: string;
  text?: string;
  children?: ReactNode;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

const Link = ({ 
  href, 
  text, 
  children, 
  className,
  style,
  onClick 
}: LinkProps) => {
  return (
    <NextLink data-component-id="src/components/ui/Link.tsx:24:4" data-component-path="src/components/ui/Link.tsx" data-component-line="24" data-component-end-line="31" data-component-file="Link.tsx" data-component-name="NextLink" data-component-content="%7B%22elementName%22%3A%22NextLink%22%2C%22href%22%3A%22%5Bvar%3Ahref%5D%22%7D" 
      href={href} 
      className={twMerge('transition-colors duration-200', className)}
      style={style}
      onClick={onClick}
    >
      {children || text}
    </NextLink>
  );
};

export default Link;